import React from "react";
import { Tabs, Tab } from "@mui/material";

const AdminTabs = ({ tabs = [], value, onChange, className, sx, ...props }) => {
  return (
    <Tabs
      value={value}
      onChange={(_, next) => onChange?.(next)}
      className={className}
      sx={{ borderBottom: 1, borderColor: "divider", minHeight: 44, ...sx }}
      variant="scrollable"
      allowScrollButtonsMobile
      {...props}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          label={tab.label}
          disabled={Boolean(tab.disabled)}
          sx={{ minHeight: 44 }}
        />
      ))}
    </Tabs>
  );
};

export default AdminTabs;
